var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plan__legal"},[(_vm.legal)?_c('div',{staticClass:"plan-box__legal"},[_c('LearnMoreLegal',{attrs:{"legal":_vm.legal,"planType":this.plan.planType,"stepClass":_vm.stepClass}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }